module.exports = __webpack_public_path__ + "static/media/icn_locations_60x60.10414cf8.svg";